
import axios, { AxiosResponse } from "axios";
import { Component, Prop, Vue } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import WsdlService from "@/services/WsdlService";
import Option from "@/models/SelectOption";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import FundType from "@/models/WsdlResponses/FundType";
import UmbracoApiService from "@/services/UmbracoApiService";
import MiInversionModel from "@/models/MiInversion/MiInversionModel";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

@Component({})
export default class TuEstadoCuentaResult extends Vue {
	@Prop() Afiliado: any;
	@Prop() Saldos: any;
	@Prop() Conceptos: any;
	@Prop() Movimientos: any;
	@Prop() EDC: any;
	//
    public tiposDeFondos: Array<Option<FundType>> = [];
    public tipoFondo: FundType = new FundType();
    public wsdlService: WsdlService = new WsdlService();
    public isLoading: boolean = false;
    public name: string = `${this.$store.state.user.primerNombre} ${this.$store.state.user.primerApellido}`;
    public email: string = this.$store.state.user.correoElectronico1;
    public userId: string = this.$store.state.user.cedula;
	public isPrinting: boolean = false;
	//tables data
	public fields2 = [];
	public items2 = [];
    public fields = [];
    public items: any = [];

    constructor() {
        super();
    }
    public rowClass(item, type) {
        if (!item || type !== "row") return;
        if (item.total) {
            return "strong-row";
        } else {
            return "normal-row";
        }
    }
	public rowClass2(item, type) {
        if (!item || type !== "row") return;
        if (item.total) {
            return "bold-text";
        } else{
			return "normal-text";
		}
    }

    public umbracoService = new UmbracoApiService();
    public miInversion = new MiInversionModel();

    async mounted() {
		this.fillMovements();
		this.fillConcepts();
	}
	public fillMovements(){
		this.fields = [
			{
				key: "concepto",
				label: this.Movimientos[0].concepto,
			},
			{
				key: "meS1",
				label: this.Movimientos[0].meS1,
				formatter: (value) => {
					return value.toLocaleString(undefined, {
						minimumFractionDigits: 2,
					});
				},
			},
			{
				key: "meS2",
				label: this.Movimientos[0].meS2,
				formatter: (value) => {
					return value.toLocaleString(undefined, {
						minimumFractionDigits: 2,
					});
				},
			},
			{
				key: "meS3",
				label: this.Movimientos[0].meS3,
				formatter: (value) => {
					return value.toLocaleString(undefined, {
						minimumFractionDigits: 2,
					});
				},
			},
			{
				key: "meS4",
				label: this.Movimientos[0].meS4,
				formatter: (value) => {
					return value.toLocaleString(undefined, {
						minimumFractionDigits: 2,
					});
				},
			},
			{
				key: "meS5",
				label: this.Movimientos[0].meS5,
				formatter: (value) => {
					return value.toLocaleString(undefined, {
						minimumFractionDigits: 2,
					});
				},
			},
			{
				key: "meS6",
				label: this.Movimientos[0].meS6,
				formatter: (value) => {
					return value.toLocaleString(undefined, {
						minimumFractionDigits: 2,
					});
				},
			}
		];
	
		this.items = this.Movimientos.slice(1);
		let length = this.items.length;
		for (let i = length - 3; i < length; i++) {
			this.items[i].total = true;
		}
	}
	public fillConcepts(){
		this.fields2 = [
			{
				key: "concepto",
				label: this.Conceptos[0].concepto,
			},
			{
				key: "mesaniO01",
				label: this.Conceptos[0].mesaniO01,
				formatter: (value) => {
					return value.toLocaleString(undefined, {
						minimumFractionDigits: 2,
					});
				},
			},
			{
				key: "mesaniO02",
				label: this.Conceptos[0].mesaniO02,
				formatter: (value) => {
					return value.toLocaleString(undefined, {
						minimumFractionDigits: 2,
					});
				},
			},
			{
				key: "mesaniO03",
				label: this.Conceptos[0].mesaniO03,
				formatter: (value) => {
					return value.toLocaleString(undefined, {
						minimumFractionDigits: 2,
					});
				},
			}
		];

		this.items2 = this.Conceptos.slice(1);
		let lastIndex = this.items2.length - 1;
		this.items2[lastIndex].total = true;
	}


    public returnForm() {
        this.$emit("returnForm");
    }
    public updateUser() {
        this.$router.push("actualizacion-de-datos");
    }
    returnHome() {
        window.location.href = GlobalConfig.PORTAL_BASE_URL
    }
	public print(){
		this.isPrinting = true;
		let element = document.getElementById('info');
		let img = new Image();
		let imgjs = (document.getElementById("instructivo") as any).src;
		img.src = imgjs;
		html2canvas(element).then(canvas => {
			let pdf = new jsPDF("p", "mm", "a4");
			let width = pdf.internal.pageSize.getWidth();
			let height = pdf.internal.pageSize.getHeight();
			let image = canvas.toDataURL('image/png');
			
			pdf.addImage(image, "PNG", 0, 0, width, height);
			pdf.addPage();
			pdf.addImage(img, "JPG", 0, 0, width, height);
			pdf.save('EstadoDeCuenta.pdf');
		});

	}
}
